import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const TrustSection = () => {
  const testimonials = [
    {
      id: 1,
      name: "Sarah Chen",
      role: "Marketing Director",
      company: "TechFlow Inc.",
      avatar: "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face",
      content: "PitchEngine AI has revolutionized our content creation process. The AI classification is incredibly accurate, and we've reduced our prompt creation time by 80%.",
      rating: 5
    },
    {
      id: 2,
      name: "Michael Rodriguez",
      role: "Legal Counsel",
      company: "Apex Legal Group",
      avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face",
      content: "The legal prompt suggestions are spot-on. It's like having an AI assistant that understands the nuances of legal documentation. Highly recommended.",
      rating: 5
    },
    {
      id: 3,
      name: "Emily Watson",
      role: "Creative Director",
      company: "Pixel Studios",
      avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
      content: "The workflow customization feature is a game-changer. We\'ve built custom prompt systems that perfectly match our creative process.",
      rating: 5
    }
  ];

  const securityBadges = [
    { icon: "Shield", label: "SSL Encrypted" },
    { icon: "Lock", label: "SOC 2 Compliant" },
    { icon: "CheckCircle", label: "GDPR Ready" },
    { icon: "Award", label: "ISO 27001" }
  ];

  const stats = [
    { value: "10,000+", label: "Active Users" },
    { value: "500K+", label: "Prompts Generated" },
    { value: "99.9%", label: "Uptime" },
    { value: "4.9/5", label: "User Rating" }
  ];

  return (
    <section className="py-20 lg:py-32 bg-surface">
      <div className="max-w-7xl mx-auto px-6">
        {/* Stats Section */}
        <div className="text-center mb-20">
          <h2 className="text-3xl md:text-4xl font-bold text-text-primary mb-4">
            Trusted by Professionals Worldwide
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mt-12">
            {stats?.map((stat, index) => (
              <div key={index} className="text-center space-y-2">
                <div className="text-3xl md:text-4xl font-bold text-primary">{stat?.value}</div>
                <div className="text-text-secondary">{stat?.label}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Testimonials */}
        <div className="mb-20">
          <h3 className="text-2xl md:text-3xl font-bold text-text-primary text-center mb-12">
            What Our Users Say
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {testimonials?.map((testimonial) => (
              <div
                key={testimonial?.id}
                className="bg-card border border-border rounded-xl p-6 hover:shadow-modal transition-state"
              >
                <div className="space-y-4">
                  {/* Rating */}
                  <div className="flex space-x-1">
                    {[...Array(testimonial?.rating)]?.map((_, i) => (
                      <Icon key={i} name="Star" size={16} color="var(--color-warning)" />
                    ))}
                  </div>

                  {/* Content */}
                  <p className="text-text-secondary leading-relaxed">
                    "{testimonial?.content}"
                  </p>

                  {/* Author */}
                  <div className="flex items-center space-x-3 pt-4 border-t border-border">
                    <Image
                      src={testimonial?.avatar}
                      alt={testimonial?.name}
                      className="w-10 h-10 rounded-full object-cover"
                    />
                    <div>
                      <div className="font-medium text-text-primary">{testimonial?.name}</div>
                      <div className="text-sm text-text-secondary">
                        {testimonial?.role} at {testimonial?.company}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Security Badges */}
        <div className="text-center">
          <h3 className="text-xl font-semibold text-text-primary mb-8">
            Enterprise-Grade Security & Compliance
          </h3>
          <div className="flex flex-wrap justify-center items-center gap-8">
            {securityBadges?.map((badge, index) => (
              <div key={index} className="flex items-center space-x-2 text-text-secondary">
                <div className="w-8 h-8 bg-success/10 rounded-lg flex items-center justify-center">
                  <Icon name={badge?.icon} size={16} color="var(--color-success)" />
                </div>
                <span className="text-sm font-medium">{badge?.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustSection;